/* eslint-disable*/

import React, { useState, useEffect } from 'react';
import useVariantsOutOfVisble from '../../../../hooks/useVariantsOutOfVisible';
import CartCtaDesktop from '../PdpCartCta/CartCtaDesktop';
import {
  VariantDescriptionCartCta,
  VariantDescriptionContainer,
  VariantGroupsContainer,
} from './VariantDescription.styles';
import VariantColors from '../VariantTypes/VariantColors';
import VariantChips from '../VariantTypes/VariantChips';
import VariantDropdown from '../VariantTypes/VariantDropdown';
import { isNotifyProductEnabled } from '@/utils/isNotifyProductEnabled';
import { getStoreType } from '@/utils/getStoreType';
import NotifyProduct from '@/components/NotifyProduct';
import { useFeatureLocks } from '@/hooks/useFeatureLocks';
import { B2B_STORE_TYPE_CONSTANT } from '@/utils/constants';
import { B2bRequestForQuoteDesktop } from '../B2b';
import { toggleRfqFormModal } from '@/redux/actions';
import { useSSRSelector } from '@/redux/ssrStore';
import { IS_CLIENT } from '../../../../utils/checkRenderEnv';
import useVariantsAvailabilityStatus from '../../../../hooks/useVariantsAvailabilityStatus';
import ProductScheduler from 'src/components/ProductScheduler';
import { useGetDeviceType } from 'src/hooks/useGetDeviceType';

const COLOR_KEY = 'Colour';

function VariantDescription(props) {
  const {
    activeIdx,
    product,
    schedualerConstraints,
    scheduleInfo,
    setScheduleInfo,
    showSchedulerError,
    setShowSchedulerError,
    ...commonCartCtaProps
  } = props;
  if (!product?.item_option_variants?.length || !product?.variants?.length) return null;
  const { item_option_variants } = product;
  const variants = product?.variants;
  const [activeVariant, setActiveVariant] = useState();
  const [toggleClick, setToggleClick] = useState(false);
  const { isMobile } = useGetDeviceType();

  const { storeData } = useSSRSelector((state) => ({
    storeData: state.storeReducer.store,
  }));

  const { notifyMeFeatureStatus } = useFeatureLocks();
  const isNotifyMeFeatureVisible = notifyMeFeatureStatus?.isVisible;

  const {
    returnIsVariantVisible,
    activeVariantOptions,
    setActiveOptionVariant,
    outOfVisbleInfo,
  } = useVariantsOutOfVisble({
    activeIdx,
    product,
    item_option_variants,
    variants,
  });

  const { setActiveVariantOptions, returnIsVariantAvailable, outOfStockInfo } =
    useVariantsAvailabilityStatus({
      activeIdx,
      product,
      item_option_variants,
      variants,
    });

  useEffect(() => {
    setActiveVariant(variants[activeIdx]);
  }, [activeIdx]);

  useEffect(() => {
    IS_CLIENT && localStorage.setItem('activeVariantId', activeVariant?.variant_id);
  }, [activeVariant]);

  function handleVariantBtnClick(rowIndex, variantName, isAvailable) {
    if (!isAvailable) return;
    let tempActiveVariantOptions = activeVariantOptions.slice(
      0,
      activeVariantOptions?.length
    );
    tempActiveVariantOptions[rowIndex] = variantName;
    let newActiveIdx = 0;
    let selectedItem = {};
    variants.forEach((item, parentIndex) => {
      let isSame = true;
      item.option_variant_names.forEach((itemOptions, index) => {
        if (isSame) {
          if (itemOptions?.variant_name !== tempActiveVariantOptions[index]) {
            isSame = false;
          }
        }
      });
      if (isSame) {
        selectedItem = item;
        newActiveIdx = parentIndex;
        if (variants[newActiveIdx].status == 2) {
          newActiveIdx = handleHiddenVariants(
            rowIndex,
            variantName,
            tempActiveVariantOptions
          );
        }
        setActiveVariantOptions(tempActiveVariantOptions);
        props?.onVariantSelect(newActiveIdx, selectedItem);
        setActiveOptionVariant(tempActiveVariantOptions);
        setActiveVariant(variants[newActiveIdx]);
        return;
      }
    });
    setToggleClick(!toggleClick);
  }

  const handleHiddenVariants = (rowIndex, variantName, tempActiveVariantOptions) => {
    let newIndex = 0;
    for (let variantIndex = 0; variantIndex < variants.length; variantIndex++) {
      if (
        variants[variantIndex].status != 2 &&
        variants[variantIndex].option_variant_names[rowIndex].variant_name ==
          variantName &&
        isVariantSameBelowRowIdx(
          variants[variantIndex],
          rowIndex,
          tempActiveVariantOptions
        )
      ) {
        newIndex = variantIndex;
        break;
      }
    }
    for (
      let variantOptionIdx = 0;
      variantOptionIdx < tempActiveVariantOptions.length;
      variantOptionIdx++
    ) {
      tempActiveVariantOptions[variantOptionIdx] =
        variants[newIndex].option_variant_names[variantOptionIdx].variant_name;
    }
    return newIndex;
  };

  const isVariantSameBelowRowIdx = (item, rowIdx, tempActiveVariantOptions) => {
    let variantOptionIdx = 0;
    while (variantOptionIdx < rowIdx) {
      if (
        item.option_variant_names[variantOptionIdx].variant_name !==
        tempActiveVariantOptions[variantOptionIdx]
      )
        return false;
      variantOptionIdx++;
    }
    return true;
  };

  function shouldDisplayNotifyMe() {
    return (
      isNotifyMeFeatureVisible &&
      product.available &&
      isNotifyProductEnabled() &&
      commonCartCtaProps?.variantOutOfStock
    );
  }

  const renderDesktopCtaButtonAccordingToStoreType = () => {
    if (getStoreType(storeData) === B2B_STORE_TYPE_CONSTANT) {
      return (
        <B2bRequestForQuoteDesktop
          openRfqFormModal={toggleRfqFormModal}
          toggleAuthModal={props.toggleAuthModal}
          product={product}
          storeInfo={props.storeInfo}
          activeVariant={activeVariant}
        />
      );
    }
    if (shouldDisplayNotifyMe() && !isMobile) {
      return <NotifyProduct product={product} activeVariant={activeVariant} />;
    }
    return (
      <CartCtaDesktop
        {...commonCartCtaProps}
        product={product}
        activeVariant={activeVariant}
        schedualerConstraints={schedualerConstraints}
        scheduleInfo={scheduleInfo}
        setShowSchedulerError={setShowSchedulerError}
      />
    );
  };

  function getCommonProps(index) {
    return {
      activeVariant,
      activeIdx,
      toggleClick,
      activeVariantOption: activeVariantOptions[index],
      outOfVisbleInfo,
      outOfStockInfo,
      handleVariantBtnClick,
      returnIsVariantVisible,
      returnIsVariantAvailable,
      storeInfo: props?.storeInfo,
      isSelectedOption: activeVariantOptions[index],
    };
  }

  function renderVariantTypeDropdown(item = {}, index) {
    return (
      <VariantDropdown
        item={item}
        index={index}
        returnIsVariantVisible={returnIsVariantVisible}
        returnIsVariantAvailable={returnIsVariantAvailable}
        activeVariantOptions={activeVariantOptions}
        handleVariantBtnClick={handleVariantBtnClick}
        storeInfo={props?.storeInfo}
      />
    );
  }

  function renderVariantTypeColor(item = {}, index) {
    return (
      <VariantColors
        item={item}
        index={index}
        activeVariant={activeVariant}
        {...getCommonProps(index)}
      />
    );
  }

  function renderVariantTypeChip(item = {}, index) {
    return <VariantChips item={item} index={index} {...getCommonProps(index)} />;
  }

  /**
   *
   * @param {*} item
   * @param {*} index
   * @description Renders different type of variant ui as per variants. For color type variant, it renders color blocks, for size chips and for custom variants it renders either dropdown/chip as per mx configuration.
   * @returns JSX
   */
  function renderVariantOptions(item, index) {
    const variantOption = Object.keys(item)[0];
    if (variantOption === COLOR_KEY) {
      return renderVariantTypeColor(item, index);
    }
    // If options_show_type for current variantOption is 1, then Dropdown is configured, Chips otherwise
    return !!product?.options_show_type?.[variantOption]
      ? renderVariantTypeDropdown(item, index)
      : renderVariantTypeChip(item, index);
  }

  return (
    !!outOfVisbleInfo?.length && (
      <VariantDescriptionContainer>
        <VariantGroupsContainer>
          {item_option_variants?.map((item, index) => renderVariantOptions(item, index))}
          <ProductScheduler
            schedualerConstraints={schedualerConstraints}
            showSchedulerError={showSchedulerError}
            setScheduleInfo={(data) => {
              setShowSchedulerError(false);
              setScheduleInfo(data);
            }}
            scheduleInfo={scheduleInfo}
            customClasses="!tw-pt-0"
          />
        </VariantGroupsContainer>
        <VariantDescriptionCartCta>
          {renderDesktopCtaButtonAccordingToStoreType()}
        </VariantDescriptionCartCta>
      </VariantDescriptionContainer>
    )
  );
}

export default VariantDescription;
